import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Card,
    Typography,
    Space,
    Button,
    message,
    Spin,
    Empty,
    Tag,
    List,
    Avatar
} from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    UserOutlined,
    EyeOutlined
} from '@ant-design/icons';
import moment from 'moment';
import auctionService from '../../services/auctionService';
import DashboardLayout from '../Dashboard/DashboardLayout';
import PageHeader from '../Common/PageHeader';

const { Title, Text, Paragraph } = Typography;

const PendingInvitations = () => {
    const [loading, setLoading] = useState(true);
    const [invitations, setInvitations] = useState([]);
    const [responding, setResponding] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loadInvitations();
    }, []);

    const loadInvitations = async () => {
        try {
            setLoading(true);
            const response = await auctionService.getPendingInvitations();
            setInvitations(response.data);
        } catch (err) {
            message.error('Failed to load invitations');
        } finally {
            setLoading(false);
        }
    };

    const handleResponse = async (auctionSlug, invitationCode, status) => {
        try {
            setResponding(true);
            await auctionService.respondToInvitation(auctionSlug, {
                invitation_code: invitationCode,
                status: status
            });
            
            message.success(`Invitation ${status} successfully`);
            loadInvitations(); // Refresh the list
        } catch (err) {
            message.error(err.response?.data?.message || 'Failed to respond to invitation');
        } finally {
            setResponding(false);
        }
    };

    const handleViewAuction = (slug) => {
        navigate(`/auctions/${slug}`);
    };

    return (
        <DashboardLayout>
            <PageHeader
                title="Pending Invitations"
                description="Review and respond to auction invitations that require your attention. Accept or decline these invitations to participate in private auctions."
            />
            <Spin spinning={loading}>
                {invitations.length === 0 ? (
                    <Empty
                        description="You have no pending invitations"
                        style={{ margin: '50px 0' }}
                    />
                ) : (
                    <List
                        dataSource={invitations}
                        renderItem={(invitation) => (
                            <Card style={{ marginBottom: '16px' }}>
                                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <Space direction="vertical" size="small">
                                            <Title 
                                                level={4} 
                                                style={{ margin: 0, cursor: 'pointer' }}
                                                onClick={() => handleViewAuction(invitation.auction.slug)}
                                            >
                                                {invitation.auction.title}
                                            </Title>
                                            <Space>
                                                <Tag icon={<ClockCircleOutlined />} color="blue">
                                                    Start: {moment(invitation.auction.start_time).format('MMM D, YYYY')}
                                                </Tag>
                                            </Space>
                                        </Space>
                                        <Space>
                                          
                                            <Button
                                                type="primary"
                                                icon={<CheckCircleOutlined />}
                                                onClick={() => handleResponse(invitation.auction.slug, invitation.invitation_code, 'accepted')}
                                                loading={responding}
                                            >
                                                Accept
                                            </Button>
                                            <Button
                                                danger
                                                icon={<CloseCircleOutlined />}
                                                onClick={() => handleResponse(invitation.auction.slug, invitation.invitation_code, 'declined')}
                                                loading={responding}
                                            >
                                                Decline
                                            </Button>
                                        </Space>
                                    </div>
                                    <Button
                                                icon={<EyeOutlined />}
                                                onClick={() => handleViewAuction(invitation.auction.slug)}
                                            >
                                                View Details
                                            </Button>
                                    {/* <Paragraph type="secondary">{invitation.auction.description}</Paragraph> */}
                                </Space>
                            </Card>
                        )}
                    />
                )}
            </Spin>
        </DashboardLayout>
    );
};

export default PendingInvitations; 